import {
  addToWeek,
  clearSlot,
  selectMealsForDateRange,
  type MealType,
  type PlannedMeal,
} from '../../redux/mealPlanSlice';
import type { Recipe } from '../../types/recipe';
import type { RootState } from '../../redux/store';

/**
 * « Remplacer » from the recipe page's plan sheet: everything in the slot goes,
 * then the recipe takes the slot.
 *
 * It used to evict only the slot's first dish. A dinner is a main and the sides
 * chosen for it (« Pour aller avec »), so replacing Wednesday's croquettes with
 * tacos left the croquettes' cucumber salad beside the tacos, and the cook had
 * to find it and remove it by hand (#845). The planner's own replace
 * (`replaceSlotRecipe`) and the sheet's move-and-replace (`clearSlot` +
 * `moveMeal`) already cleared the whole slot; this is the same rule.
 *
 * Returns what was evicted, so the caller can name it in the toast. The caller
 * snapshots the week first: the evicted meals keep their id, cook status and
 * note only through that snapshot's undo.
 */
export function replaceSlotWithRecipe(
  dispatch: (action: unknown) => unknown,
  getState: () => RootState,
  {
    recipe,
    scheduledFor,
    mealType,
    servings,
    cooked,
  }: {
    recipe: Recipe;
    scheduledFor: string;
    mealType: MealType;
    servings: number;
    /** « Oui, je l'ai cuisinée » on a day that is over (#846). */
    cooked?: boolean;
  },
): PlannedMeal[] {
  const evicted = selectMealsForDateRange(getState(), scheduledFor, scheduledFor)
    .filter((m) => m.mealType === mealType);
  dispatch(clearSlot({ scheduledFor, mealType }));
  dispatch(addToWeek({ recipe, scheduledFor, mealType, servings, cooked }));
  return evicted;
}
